<div
  class="rotulo-container"
  (dblclick)="onDoubleClick()">
  {{ tituloIdOrigemId }}
</div>
